/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CompetenzaMeseAnnoOutputDto interface.
 */
export function instanceOfCompetenzaMeseAnnoOutputDto(value) {
    return true;
}
export function CompetenzaMeseAnnoOutputDtoFromJSON(json) {
    return CompetenzaMeseAnnoOutputDtoFromJSONTyped(json, false);
}
export function CompetenzaMeseAnnoOutputDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'mese': json['mese'] == null ? undefined : json['mese'],
        'anno': json['anno'] == null ? undefined : json['anno'],
        'totImportoFatture': json['totImportoFatture'] == null ? undefined : json['totImportoFatture'],
        'afRicavi': json['afRicavi'] == null ? undefined : json['afRicavi'],
        'importoFatturato': json['importoFatturato'] == null ? undefined : json['importoFatturato'],
        'automatic': json['automatic'] == null ? undefined : json['automatic'],
        'agg': json['agg'] == null ? undefined : json['agg'],
        'competenza': json['competenza'] == null ? undefined : json['competenza'],
        'acosti': json['acosti'] == null ? undefined : json['acosti'],
    };
}
export function CompetenzaMeseAnnoOutputDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'mese': value['mese'],
        'anno': value['anno'],
        'totImportoFatture': value['totImportoFatture'],
        'afRicavi': value['afRicavi'],
        'importoFatturato': value['importoFatturato'],
        'automatic': value['automatic'],
        'agg': value['agg'],
        'competenza': value['competenza'],
        'acosti': value['acosti'],
    };
}
